/**
 * Eltern-push-templates — texte vom hitzeschutzbeauftragte-agent (Phase 13,
 * 2026-05-23) gegen ASR A3.5, HMKB-erlass Hessen, BIÖG-empfehlung und
 * HWG/BGB-§831/§832-haftungsregeln validiert.
 *
 * Rechtssichere kernprinzipien:
 *   - keine erfolgs-garantien ("wir setzen aus" statt "wir garantieren kühle räume")
 *   - keine medizinischen diagnose-listen (HWG-konflikt vermeiden)
 *   - stufe-4-abhol-formulierung als ELTERN-RECHT, nicht schul-direktive
 *     (schulpflicht §§ 63–68 HSchG Hessen bleibt schulleitungs-entscheidung)
 *
 * Stufen-mapping (ASR A3.5 §4.2):
 *   2 → soll-bereich (26–30°C)
 *   3 → muss-bereich (30–35°C)
 *   4 → kritisch / raum als arbeitsraum ungeeignet (>35°C)
 *
 * Stufe 1 (≤26°C) hat keine eltern-info-pflicht und kein template.
 *
 * Texte sind max 320 zeichen (whatsapp-message-länge), deutsche
 * fachsprache, höfliche anrede ohne du-form, ohne emoji im body
 * (1 ☀️ am titel-anfang als opt-in tonality-cue).
 */
export interface ElternPushTemplate {
  level: 2 | 3 | 4;
  title: string;
  body: string;
}

export const ELTERN_TEMPLATES: Record<2 | 3 | 4, ElternPushTemplate> = {
  2: {
    level: 2,
    title: "☀️ Hitzestufe 2 heute — Information",
    body:
      "Liebe Eltern,\n\n" +
      "unser Hitzeprotokoll zeigt heute Hitzestufe 2. Wir lüften die Räume " +
      "morgens und sorgen für Schattenpausen. Bitte geben Sie Ihrem Kind eine " +
      "gefüllte Trinkflasche mit. Ihr Kind wird gut betreut.",
  },
  3: {
    level: 3,
    title: "☀️ Hitzestufe 3 heute — Maßnahmen aktiv",
    body:
      "Liebe Eltern,\n\n" +
      "unser Hitzeprotokoll zeigt heute Hitzestufe 3 — Pflichtmaßnahmen sind " +
      "aktiv. Wir setzen anstrengende Aktivitäten aus, verlängern Schattenpausen " +
      "und stellen Trinkwasser bereit. Bitte schicken Sie Ihr Kind mit ausreichend " +
      "Wasser, einer Kopfbedeckung und luftiger Kleidung. Bei Auffälligkeiten " +
      "informieren wir Sie umgehend.",
  },
  4: {
    level: 4,
    title: "☀️ Hitzestufe 4 — kritisch, bitte lesen",
    body:
      "Liebe Eltern,\n\n" +
      "unser Hitzeprotokoll zeigt Hitzestufe 4 — Räume über 35 °C. " +
      "Außenaktivitäten sind ausgesetzt. Wir behalten Ihr Kind besonders " +
      "aufmerksam im Blick. Sie können Ihr Kind bei Bedarf früher abholen — " +
      "bitte kurz Bescheid geben. Bitte ausreichend Wasser und Sonnenschutz " +
      "mitgeben.",
  },
};

/**
 * Liefert template für eine gegebene stufe, oder null wenn stufe keine
 * eltern-info erfordert (stufe 1).
 */
export function getElternTemplate(level: 1 | 2 | 3 | 4): ElternPushTemplate | null {
  if (level === 1) return null;
  return ELTERN_TEMPLATES[level];
}
